<template>
  <div>
    <WebsiteHeader></WebsiteHeader>
    <v-row class="mt-16 pt-4 mb-16 pt-16">
      <v-stepper v-model="step">
        <v-stepper-header>
          <v-stepper-step :complete="step > 1" step="1">
            Create User Account
          </v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step :complete="step > 2" step="2">
            Create Company
          </v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step step="3"> Complete Payment </v-stepper-step>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content step="1">
            <vAlertHeader
              title="1. Create User Account"
              color="#0D47A1"
            ></vAlertHeader>
            <v-card class="mb-12" color="grey lighten-1">
              <v-row class="px-4 py-2">
                <v-col :cols="isMobile ? 12 : 4">
                  <v-text-field
                    label="User Full Names"
                    v-model="user.name"
                  ></v-text-field>
                </v-col>

                <v-col :cols="isMobile ? 12 : 4">
                  <v-text-field
                    label="User Phone Contact"
                    v-model="user.tel"
                  ></v-text-field>
                </v-col>

                <v-col :cols="isMobile ? 12 : 4">
                  <v-text-field
                    label="User Email"
                    v-model="user.email"
                  ></v-text-field>
                </v-col>

                <v-col :cols="isMobile ? 12 : 4">
                  <v-text-field
                    label="Secret Password"
                    :type="passwordType"
                    v-model="user.password"
                  ></v-text-field>
                  <span
                    ><v-checkbox
                      color="teal"
                      label="Show Password"
                      @click="showPassword()"
                      v-model="passCheckbox"
                    ></v-checkbox
                  ></span>
                </v-col>

                <!-- <v-col :cols="isMobile ? 12 : 4">
                  <v-text-field
                    label="User Email"
                    v-model="user.email"
                  ></v-text-field>
                </v-col> -->
              </v-row>
            </v-card>

            <v-btn color="primary" @click="goToStep2()"> Continue </v-btn>

            <v-btn text @click="cancelOnboarding()"> Cancel </v-btn>
          </v-stepper-content>

          <v-stepper-content step="2" :class="isMobile ? 'mb-10' : ''">
            <vAlertHeader
              title="2. Create Company"
              color="#3E2723"
            ></vAlertHeader>
            <v-card class="mb-12" color="grey lighten-1">
              <v-row class="px-4 py-2">
                <v-col :cols="isMobile ? 12 : 4">
                  <v-text-field
                    v-model="company.name"
                    label="Company Name"
                  ></v-text-field>
                </v-col>

                <v-col :cols="isMobile ? 12 : 4">
                  <v-text-field
                    v-model="company.primary_phone"
                    label="Company Phone Number"
                  ></v-text-field>
                </v-col>

                <v-col :cols="isMobile ? 12 : 4">
                  <v-text-field
                    v-model="company.primary_address"
                    label="Company Physical Address"
                  ></v-text-field>
                </v-col>

                <v-col :cols="isMobile ? 12 : 4">
                  <v-text-field
                    v-model="company.city"
                    label="Company Physical Address"
                  ></v-text-field>
                </v-col>

                <v-col :cols="isMobile ? 12 : 4">
                  <v-text-field
                    v-model="company.email"
                    label="Company Email"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-card>

            <v-btn color="primary" @click="goToStep3()"> Continue </v-btn>

            <v-btn text @click="cancelOnboarding()"> Cancel </v-btn>
          </v-stepper-content>

          <v-stepper-content step="3">
            <vAlertHeader
              title="3. Complete Payment"
              color="#1B5E20"
            ></vAlertHeader>
            <v-card class="mb-12" color="grey lighten-1">
              <v-row v-if="step == 3" class="px-4 py-4">
                <v-col :cols="isMobile ? 12 : 4"
                  ><CouponForm
                    :selectedPlan="selectedPlan"
                    :company="company"
                  ></CouponForm
                ></v-col>
                <v-col :cols="isMobile ? 12 : 4"
                  ><PayfastPayment
                    :selectedPlan="selectedPlan"
                    :company="company"
                  ></PayfastPayment
                ></v-col>
                <v-col :cols="isMobile ? 12 : 4"
                  ><PayPalPayment
                    :selectedPlan="selectedPlan"
                    :company="company"
                  ></PayPalPayment
                ></v-col>
              </v-row>
            </v-card>

            <!-- <v-btn color="primary" @click="step = 1"> Continue </v-btn> -->

            <v-btn text @click="cancelOnboarding()"> Cancel </v-btn>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-row>

    <WebsiteFooter class="mt-16 pt-16"></WebsiteFooter>
  </div>
</template>
<script>
import vAlertHeader from "@/components/Legos/vAlertHeader.vue";
import WebsiteHeader from "@/components/SchoolWebsite/WebsiteHeader.vue";
import WebsiteFooter from "@/components/SchoolWebsite/WebsiteFooter.vue";
import PayfastPayment from "./PayfastPayment.vue";
import PayPalPayment from "./PayPalPayment.vue";
import CouponForm from "./CouponForm";
export default {
  components: {
    vAlertHeader,
    PayfastPayment,
    PayPalPayment,
    CouponForm,
    WebsiteHeader,
    WebsiteFooter,
  },
  computed: {
    isMobile() {
      return this.$store.getters.isMobile;
    },
  },
  data: () => ({
    selectedPlan: {
      price: 0,
    },
    passwordType: "password",
    passCheckbox: null,
    step: 1,
    company: {
      name: "Company Name",
      primary_phone: "012 345 6789",
      email: "company@gmail.com",
      primary_address: "123 Ken Street",
      city: "Durban",
      postal_code: "4001",
      vat_number: "4230240000",
      reg_number: "2002/032291/01",
      emis: null,
      tax_rate: 0,
    },
    user: {
      emis: null,
      sid: null,
      alevel: 7,
      token: null,
      name: null,
      email: null,
      tel: null,
      password: null,
    },
  }),

  mounted() {
    this.selectedPlan = this.$route.query.plan;
    this.generateCompanyEmis();
  },
  methods: {
    generateCompanyEmis() {
      this.company.emis = new Date().valueOf();
    },
    showPassword() {
      if (this.passCheckbox) {
        this.passwordType = "text";
      } else {
        this.passwordType = "password";
      }
    },
    goToStep2() {
      if (
        !this.user.name ||
        !this.user.email ||
        !this.user.tel ||
        !this.user.password
      ) {
        alert("All Fields Are Required!");
        return false;
      }
      this.user.emis = this.company.emis;
      localStorage.setItem("user", JSON.stringify(this.user));
      this.step = 2;
    },
    goToStep3() {
      if (
        !this.company.name ||
        !this.company.primary_phone ||
        !this.company.primary_address ||
        !this.company.city
      ) {
        alert("Company Name, Phone, City and Address Are Required!");
        return false;
      }

      localStorage.setItem("company", JSON.stringify(this.company));
      this.step = 3;
    },
    cancelOnboarding() {
      localStorage.removeItem("user");
      localStorage.removeItem("company");
      this.$router.push({ path: "/home" });
    },
  },
};
</script>
